<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <disability-form :itemId="id" formType="Edit" subTitle="Edit Disability"></disability-form>
      </div>
    </div>
  </div>
</template>

<script>
import DisabilityForm from "@/views/disabilities/components/Form.vue";

export default {
  name: "edit-disability",
  data(){
    return {
      id : this.$route.params.id
    }
  },
  components: {
    DisabilityForm,
  }
};
</script>